import {
	CLEAR_DELETE_WEB_SEARCH_MODAL,
	CLOSE_DELETE_WEB_SEARCH_MODAL,
	CLOSE_SAVED_WEB_SEARCHES_MODAL,
	CLOSE_WEB_PAGES_MODAL,
	CLOSE_WEB_PAGES_SAVE_AS_MODAL,
	LOAD_SAVED_WEB_SEARCH,
	OPEN_DELETE_WEB_SEARCH_MODAL,
	OPEN_SAVED_WEB_SEARCHES_MODAL,
	OPEN_WEB_PAGES_MODAL,
	OPEN_WEB_PAGES_SAVE_AS_MODAL,
	SET_WEB_PAGES_SEARCH,
	SET_WEB_SEARCHES_AVAILABLE,
	STORE_FILTERS_FOR_ROUTE_CHANGE,
	UPDATE_WEB_PAGES_QUERY,
	SET_CURRENT_WEB_PAGES_COLLECTION_ID,
	RESET_DOCUMENT_SUMMARIZATION,
} from "actions/constants.js";

import { setActiveChatConfig } from 'actions/chatActions';
import { DATASET_ID_WEB} from 'layout/DataExplorer/DataExplorerConstants.js';

export const updateQuery = ({ queryString }) => {
	return {
		type: UPDATE_WEB_PAGES_QUERY,
		queryString,
	};
};

export const loadSavedWebSearch = (params) => {
	const { query, name, id, filterStr, savedSearches } = params;
	return {
		type: LOAD_SAVED_WEB_SEARCH,
		queryString: query,
		queryId: id,
		name,
		filterString: filterStr,
		savedSearches,
	};
};

export const storeFiltersForRouteChange = (filterString) => {
	return (dispatch) => {
		dispatch({ type: STORE_FILTERS_FOR_ROUTE_CHANGE, filterString });
	};
};

export const setWebPagesSearch = ({ id, name }) => {
	return (dispatch) => {
		dispatch({ type: SET_WEB_PAGES_SEARCH, name, id });
	};
};

export const setWebSearchesAvailable = (available) => {
	return {
		type: SET_WEB_SEARCHES_AVAILABLE,
		available,
	};
};

export const closeSavedWebSearchesModal = () => {
	return {
		type: CLOSE_SAVED_WEB_SEARCHES_MODAL,
	};
};
export const openSavedWebSearchesModal = () => {
	return {
		type: OPEN_SAVED_WEB_SEARCHES_MODAL,
	};
};

export const closeWebPagesModal = () => {
	return (dispatch) => {
		// Reset URL to base web path
		const baseUrl = "/web";
		window.history.pushState({ path: baseUrl }, "", baseUrl);
		// Clear single doc chat config
		dispatch(setActiveChatConfig("single", null));
		// Dispatch original close actions
		dispatch({ type: CLOSE_WEB_PAGES_MODAL });
		dispatch({ type: RESET_DOCUMENT_SUMMARIZATION });
	};
};
export const openWebPagesModal =
	({ html_hash, url_hash }) =>
	(dispatch, getState) => {
		// Initialize single doc chat config if opening without any pre-loaded config
		const { activeConfigs } = getState().chat;
		if (!activeConfigs["single"]) {
			dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_WEB}));
		}

		// Try to get collection id from URL path first, fallback to state if not present
		const pathParts = window.location.pathname.split("/");
		let currentCollectionId = pathParts.length > 2 ? pathParts[2] : null;
		if (!currentCollectionId) {
			const {
				webPagesTab: { currentCollectionId: stateCollectionId },
			} = getState();
			currentCollectionId = stateCollectionId;
		}

		// Try to get project from URL first, fallback to state if not present
		let currentProject = new URLSearchParams(window.location.search).get("project");
		if (!currentProject) {
			const {
				login: { availableProjects, currentProject: stateProject },
			} = getState();
			currentProject = availableProjects.find(x => x.id === stateProject)?.name;
		}

		// Construct the new URL with search params
		const searchParams = new URLSearchParams();
		if (currentProject) {
			searchParams.set("project", currentProject);
		}

		// Create the URL using base web path
		const newUrl = `/web/${currentCollectionId}/${html_hash}/${url_hash}?${searchParams.toString()}`;
		window.history.pushState({ path: newUrl }, "", newUrl);

		// Dispatch original modal action
		dispatch({
			type: OPEN_WEB_PAGES_MODAL,
			html_hash,
			url_hash,
			collectionId: currentCollectionId,
		});
	};

// ------- Save As modal --------
export const closeWebPagesSaveAsModal = () => {
	return {
		type: CLOSE_WEB_PAGES_SAVE_AS_MODAL,
	};
};
export const openWebPagesSaveAsModal = ({ title, filterString }) => {
	return {
		type: OPEN_WEB_PAGES_SAVE_AS_MODAL,
		title,
		filterString,
	};
};

export const closeDeleteWebSearchModal = () => {
	return (dispatch) => {
		dispatch({ type: CLOSE_DELETE_WEB_SEARCH_MODAL });
		setTimeout(() => {
			dispatch({ type: CLEAR_DELETE_WEB_SEARCH_MODAL });
		}, 400);
	};
};
export const openDeleteWebSearchModal = (search) => {
	return {
		type: OPEN_DELETE_WEB_SEARCH_MODAL,
		search,
	};
};
export const setCurrentCollectionId = (id) => {
	return {
		type: SET_CURRENT_WEB_PAGES_COLLECTION_ID,
		id,
	};
};
